import * as types from '../ActionTypes';
import { user, saas } from '@/services';

const state = {
	isLoading: false,
	imgItems: [],
	userInfo: {},
	userInfoPart: {},
	userDomain: '',
};
const mutations = {
	[types.SET_USERINFO](st, data) {
		st.userInfo = data;
	},
	[types.SET_USERINFOPART](st, data) {
		st.userInfoPart = data;
	},
	[types.SET_USERDOMAIN](st, data) {
		st.userDomain = data;
	},
};
const actions = {
	async getUserInfo({ state, commit }, payload) {
		const { ok, data } = await user.getUserInfo(payload);
		if (ok) {
			commit('SET_USERINFO', data.data);
			commit('SET_USERINFOPART', data.data);
		}
	},
	async getUserDomain({ state, commit }, userId) {
		const { ok, data } = await saas.getUserDomain(userId);
		if (ok) {
			commit('SET_USERDOMAIN', data.data);
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
